import { useSelector, useDispatch } from 'react-redux';
import Barraschart from './barChart';
import Loader from '../loader';

function Barchart() {
  const dispatch = useDispatch();
  const { dashboard } = useSelector((state) => state.fuse);
  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);

  const initialGruposChartData = [
    {
      tipoinmuebleid: '1',
      dsinmueble: 'Sin Datos',
      total: 0,
      verde: 0,
      amarillo: 0,
      rojo: 0,
      gris: 0,
    },
  ];

  const initialInmueblesChartData = [
    {
      grupoinmuebleid: '1',
      dsgrupoinmueble: 'Sin Datos',
      total: 0,
      verde: 0,
      amarillo: 0,
      rojo: 0,
      gris: 0,
    },
  ];

  const chartStyle = {
    backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white',
  };

  return (
    <>
      <div className="grid-chart">
        {dashboard?.errorChart?.name === 'AxiosError' ? (
          <>
            <div className="flex mb-4" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Loader nameComponent="graphics" nameLabel="Graficas" loader={dashboard?.loadingCharts || false} />
            </div>
          </>
        ) : (
          <>
            <div
              className="flex max-w-full max-h-sm gap-0 m-10 rounded-lg"
              style={chartStyle}
            >
              <Barraschart initialData={initialGruposChartData} title="Grupos de Inmuebles" axisXKey="dsgrupoinmueble" />
            </div>
            <div
              className="flex max-w-full max-h-sm gap-0 m-10 rounded-lg"
              style={chartStyle}
            >
              <Barraschart initialData={initialInmueblesChartData} title="Tipos de Inmueble" axisXKey="dsinmueble" />
            </div>
          </>
        )}
      </div>
    </>
  );
}
export default Barchart;
